import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { deletPayslip, Genratepayslip, getallPayslip, getpayslipEmployee, generatePayslipPdfs, publishPayslips, sendPayslipEmails } from '../api';
import { useAlert } from '../context/AlertContext';


export const useGeneratePayslips = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: Genratepayslip,
    onSuccess: (data) => {
      // console.log('Payslips generated successfully:', data);
      queryClient.invalidateQueries(['payslips']); // Adjust this query key if needed
    },
    onError: (error) => {
      console.error('Error generating payslips:', error);
    },
  });
};

export const useGeneratePayslipPdfs = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: generatePayslipPdfs,
    onSuccess: (data) => {
      queryClient.invalidateQueries(['payslips']);
    },
    onError: (error) => {
      console.error('Error generating Paylslip PDFs:', error);
    },
  });
};

export const usePublishPayslips = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: publishPayslips,
    onSuccess: (data) => {
      queryClient.invalidateQueries(['payslips']);
    },
    onError: (error) => {
      console.error('Error Publishing Payslips:', error);
    },
  });
};

export const useSendPayslipEmails = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: sendPayslipEmails,
    onSuccess: () => {
      queryClient.invalidateQueries(['payslips']);
    },
    onError: (error) => {
      console.error('Error emailing payslips:', error);
    },
  });
};

export const usePaySlipEmployee = (id) => {
  return useQuery({
    queryKey: ['singleEmployee', id], // Pass an array as the key
    queryFn: getpayslipEmployee,      // Use an API function compatible with v5
    enabled: !!id,                   // Only fetch if `id` is truthy
  });
};

export const usePaysliplist = (params = {}) => {
  return useQuery({
    queryKey: ['payslips', params],
    queryFn: () => getallPayslip(params),
    keepPreviousData: true, // Keep old data while fetching new page
  })
}

export const useDeletePayslip = () => {
  const queryClient = useQueryClient();
  const { showSuccess, showError } = useAlert()

  return useMutation({

    mutationFn: (id) => deletPayslip(id),
    onSuccess: (data) => {
      // console.log(data);
      showSuccess('Deleted Succesfully');
      queryClient.invalidateQueries(['payslips'])
    },
    onError: (error) => {
      console.error(error);
      showError("Error While deleting")
    }
  })
};